import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StaffFilter } from '@/api/DTO/staff/staffList.interface';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';

export default function SubFaqListSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<StaffFilter>();

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid item xs={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
		</Grid>
	);
}
